module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "review_tag"
  }, _vm._l((_vm.reviewTags), function(item, index) {
    return _c('el-tag', {
      staticClass: "tagefer",
      attrs: {
        "type": "primary",
        "color": "white"
      }
    }, [_vm._v("\n      " + _vm._s(item.tag.value) + "(" + _vm._s(item.count) + ")\n    ")])
  })), _vm._v(" "), _vm._l((_vm.reviews), function(item) {
    return _c('div', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('el-row', {
      staticClass: "pinglun_row"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "12px",
        "color": "#686868",
        "white-space": "normal",
        "margin-bottom": "10px"
      }
    }, [_vm._v("\n          " + _vm._s(item.content) + "\n        ")]), _vm._v(" "), _vm._l((item.tags), function(tag) {
      return _c('span', [_vm._v(_vm._s(tag.tag.value))])
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "color": "#9a9a9a"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.getLocalTime(item.createAt)) + "\n        ")])], 2), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 12
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "15px"
      }
    }), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "12px",
        "color": "#333"
      }
    }, [_vm._v("\n          用户：" + _vm._s(item.user.phone) + "\n        ")])])], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-9dce52c4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ReviewList.vue
// module id = 1060
// module chunks = 40